module.exports = __webpack_public_path__ + "img/GALLERY-VITARA-4.03f610b0.jpg";